import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CalculationResults } from '../../backend-response-models/calc-interfaces.helper';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CalculationService {
  constructor(private httpClient: HttpClient) {}

  async getCalculationForSubjectId(subjectId: number): Promise<CalculationResults> {
    const headers = new HttpHeaders().set('x-api-key', 'mytestkey');
    const options = { headers: headers };
    const apiBaseUrl = environment.apiBaseUrl;

    const data = await firstValueFrom(
      this.httpClient.get<CalculationResults>(`${apiBaseUrl}/subjects/${subjectId}/calculate-premo`, options)
    );
    return data;
  }

  async getCalculationWithTokenAndId(token: string, id: string, useInternalAPI: boolean): Promise<CalculationResults> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    const options = { headers: headers };
    const apiBaseUrl = useInternalAPI ? environment.apiBaseUrlForPDF : environment.apiBaseUrl;
    const fullUrl = `${apiBaseUrl}/dashboard/${id}`;
    console.log(` fullUrl: ${fullUrl}`);
    const data = await firstValueFrom(this.httpClient.get<CalculationResults>(fullUrl, options));
    console.log(`data did return`);
    return data;
  }
}
